import React, { useMemo } from 'react';
import { WORLD_MAP_POINTS, WORLD_MAP_VIEWBOX_HEIGHT } from '../data/worldMapPoints';

const GLIMMER_RATIO = 0.15;

const WorldMapBackground: React.FC = () => {
  const dots = useMemo(
    () =>
      WORLD_MAP_POINTS.map(([x, y]) => ({
        x,
        y,
        glimmer: Math.random() < GLIMMER_RATIO,
        duration: 1.8 + Math.random() * 2.2,
        delay: Math.random() * 4,
      })),
    []
  );

  return (
    <svg
      data-testid="world-map-background"
      viewBox={`0 0 100 ${WORLD_MAP_VIEWBOX_HEIGHT}`}
      preserveAspectRatio="xMidYMid slice"
      className="absolute inset-0 w-full h-full"
      aria-hidden="true"
    >
      {dots.map((dot, i) =>
        dot.glimmer ? (
          <circle
            key={i}
            cx={dot.x}
            cy={dot.y}
            r={0.42}
            fill="#38bdf8"
            opacity={0.15}
            style={{
              animation: `world-map-glimmer ${dot.duration}s ease-in-out ${dot.delay}s infinite`,
            }}
          />
        ) : (
          <circle key={i} cx={dot.x} cy={dot.y} r={0.38} fill="#ffffff" opacity={0.1} />
        )
      )}
    </svg>
  );
};

export default WorldMapBackground;
